import { render } from "./ShowLivescoringResultDialog.vue?vue&type=template&id=5895d326&scoped=true"
import script from "./ShowLivescoringResultDialog.vue?vue&type=script&lang=js"
export * from "./ShowLivescoringResultDialog.vue?vue&type=script&lang=js"

import "./ShowLivescoringResultDialog.vue?vue&type=style&index=0&id=5895d326&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5895d326"]])

export default __exports__